var map = {
	"./en/img/flag.svg": 57444,
	"./fr/img/flag.svg": 24519,
	"./fr/img/sfl-logo-green.svg": 9676,
	"./fr/img/sfl-logo-white.svg": 56594,
	"./fr/img/sfl-logo.svg": 76566,
	"./fr/img/sr-logo.svg": 32962,
	"./share/img/flag.svg": 26060,
	"./share/img/rewards-logo.png": 80602,
	"./share/img/sfl-logo-green.svg": 7271,
	"./share/img/sfl-logo-small-green.svg": 56437,
	"./share/img/sfl-logo-white.svg": 90101,
	"./share/img/sfl-logo.svg": 68193,
	"./share/img/sr-logo.svg": 30503
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21168;